export default __webpack_public_path__ + "static/media/No35Open.2e4944e6.jpg";